import React from 'react';

const TiuvShemotTitle = () => {
  return <span>רשימת טיוב שמות</span>;
};

export default TiuvShemotTitle;
